export default "__VITE_PUBLIC_ASSET__3bcb7666__"